<template>
  <header class="header-expanded py-6 px-5 relative box-border w-full" :class="$dm('bg-white', 'dark:bg-slate-900')" style="border-bottom: 1px solid #e0e0e0">
    <div class="flex items-center">
      <div v-if="avatarUrl" class="flex-shrink-0 mr-3 flex items-center">
        <img class="h-10 w-10 rounded-lg" :src="avatarUrl" alt="avatar" />
      </div>
      <div class="flex-1 flex flex-col justify-center">
        <h2 class="text-lg font-bold" :class="$dm('text-slate-900', 'dark:text-slate-50')" v-html="introHeading" />
        <p class="text-base leading-normal" :class="$dm('text-slate-700', 'dark:text-slate-200')" v-html="introBody" />
      </div>
      <div class="ml-5 flex items-center">
        <header-actions :show-popout-button="showPopoutButton" />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderActions from './HeaderActions';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
  },
  mixins: [darkModeMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
  },
};
</script>
